exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donation-form-en[data-v-ff792004]{font-family:CoFo Sans;font-weight:400}.donation-form-en .currency-switcher[data-v-ff792004],.donation-form-en .extra-rate[data-v-ff792004],.donation-form-en .mode-switcher[data-v-ff792004],.donation-form-en fieldset[data-v-ff792004],.donation-form-en input[data-v-ff792004],.donation-form-en select[data-v-ff792004],.donation-form-en textarea[data-v-ff792004]{margin-bottom:10px}.donation-form-en .method-description[data-v-ff792004]{margin-bottom:10px!important}", ""]);

// exports
